import type { AccessCatalogItemPublic, UserPublic } from '@accounts/shared';

import { STR } from '../../../../i18n';
import { Modal, ModalParagraph, ModalProse } from '../../../../ui/Modal';
import { Callout } from '../../../../ui/Primitives';
import { modalButtonStyle } from '../../../../ui/styles';
import { itemLabel } from '../accessFormat';

/**
 * An empty Matrix cell (FINAL demo `mxCellModal`, no record): "No access recorded", with
 * Cancel and Add access…. Only Add access… opens the add form. A deactivated person gets
 * no Add access…: the demo says they are deactivated and offers Cancel alone.
 */
export function EmptyCellDialog({
  person,
  item,
  onClose,
  onAdd,
}: {
  person: UserPublic;
  item: AccessCatalogItemPublic;
  onClose: () => void;
  onAdd: () => void;
}) {
  return (
    <Modal
      title={STR.access.record.viewTitle(item.name, person.name)}
      lead={STR.access.matrix.emptyLead}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="ghost" style={modalButtonStyle} onClick={onClose}>
            {STR.common.cancel}
          </button>
          {person.active ? (
            <button type="button" className="prim" style={modalButtonStyle} onClick={onAdd}>
              {STR.access.matrix.emptyAdd}
            </button>
          ) : null}
        </>
      }
    >
      {person.active ? (
        <ModalProse>
          <ModalParagraph>
            {STR.access.matrix.emptyBody(person.name, itemLabel(item.path, item.name))}
          </ModalParagraph>
        </ModalProse>
      ) : (
        <div style={{ padding: '18px 22px' }}>
          <Callout tone="neutral">{STR.access.matrix.emptyDeactivated(person.name)}</Callout>
        </div>
      )}
    </Modal>
  );
}
